export const FILE_EXTENSIONS_KEYS = {
  CSV: 'csv',
  XLSX: 'xlsx',
};

export const FILE_EXTENSIONS_LABELS = {
  [FILE_EXTENSIONS_KEYS.CSV]: 'CSV',
  [FILE_EXTENSIONS_KEYS.XLSX]: 'Excel',
};

export const FILE_EXTENSIONS_DOWNLOAD_LABELS = {
  [FILE_EXTENSIONS_KEYS.CSV]: 'Descargar en CSV',
  [FILE_EXTENSIONS_KEYS.XLSX]: 'Descargar en Excel',
};

export const FILES_EXTENSIONS = {
  CSV: {
    label: FILE_EXTENSIONS_LABELS[FILE_EXTENSIONS_KEYS.CSV],
    key: FILE_EXTENSIONS_KEYS.CSV,
    downloadLabel: FILE_EXTENSIONS_DOWNLOAD_LABELS[FILE_EXTENSIONS_KEYS.CSV],
  },
  XLSX: {
    label: FILE_EXTENSIONS_LABELS[FILE_EXTENSIONS_KEYS.XLSX],
    key: FILE_EXTENSIONS_KEYS.XLSX,
    downloadLabel: FILE_EXTENSIONS_DOWNLOAD_LABELS[FILE_EXTENSIONS_KEYS.XLSX],
  },
};
